<template>
  <footer class="flex bg-transparent w-full justify-end px-8 pb-4">
    <div class="font-medium text-gray-900 flex flex-col">
      <div class="text-gray-900 flex items-center mb-1">© Copyright &nbsp;
        <a href="http://www.exenzo.com/" class="exenzo-link text-info" target="_blank" rel="noopener">
          EXENZO Software
        </a>
      </div>
      <div class="flex justify-center mb-1">
        <a href="http://www.exenzo.com/" target="_blank" rel="noopener">
          <img class="exenzo-logo"
               src="static/img/exenzo-logo.png"
               alt="Exenzo logo">
        </a>
      </div>
      <div class="text-center">
        <small class="text-center text-sm">
          Version {{version}}
        </small>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'main-footer',
    data () {
      return {
        version: '1.3.16'
      }
    }
  }
</script>
<style scoped lang="scss">
  .exenzo-logo {
    height: 15px;
    opacity: 0.85;
  }

  .exenzo-link {
    text-decoration: none;
    font-weight: bold;

    &:hover {
      text-decoration: none;
    }
  }
</style>
